/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { getBlockComment } from '../getBlockComment/getBlockComment';

export function getBuilderUrlComment( builderUrl: string ): string {
	return getBlockComment( [
		'This configuration was generated using the CKEditor 5 Builder. You can modify it anytime using this link:',
		builderUrl
	] );
}
